import React, { Component } from "react";
import { ReactComponent as Calendar } from "../../../assets/svg/calendar.svg";
import "../../MainContent/Dashboard/Filters/Flatpickr.css";
import Flatpickr from "react-flatpickr";
import "./LoginLogs.scss";

const CalendarModel = (props) => {
    const options = {
        mode: "range",
        monthSelectorType: "static",
        yearSelectorType: "static",
        allowInput: false,
        altInput: true,
        altFormat: "M j, Y",
        dateFormat: "Y-M-d",
        wrap: true,
        maxDate: !props.smpCalender && new Date().fp_incr(0),
    };

    return (
        <Flatpickr
            data-input
            options={options}
            onClose={(selectedDates, dateStr, instance) => {
                props.onModalClose(selectedDates);
            }}
            onReady={(_, __, fp) => {
                fp.calendarContainer.classList.add("skiptranslate");
                fp.calendarContainer.classList.add("filter-custom-duration");
            }}
            value={props.date}
            onChange={(selectedDates, dateStr, instance) => {
                props.onValueChange && props.onValueChange(selectedDates);
            }}>
            <Calendar data-toggle />

            <input type="text" className="clanderinput" placeholder={`${props.start} to ${props.end}`} data-input />
        </Flatpickr>
    );
};

export default CalendarModel;
